"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
class AdAdapterBase {
  constructor(options, context) {
    this.options = options;
    this.context = context;
  }
  destroy() {
    this.options = null;
    this.context = null;
  }
  getId() {
    return "base";
  }
  get info() {
    return {
      id: this.getId(),
      version: "",
      adTechnology: ""
    };
  }
  get player() {
    return this.context.player;
  }
  get aviaSdk() {
    return this.context.avia;
  }
  get csaiCfg() {
    return this.context.resource.ad.csai;
  }
  get logger() {
    return this.context.logger;
  }
  log(msg, obj) {
    this.logger.debug(msg);
    if (obj) {
      for (const q in obj) {
        this.logger.debug(`${q}: ${obj[q]}`);
      }
    }
  }
}
var VideoAutoplayType = /* @__PURE__ */ ((VideoAutoplayType2) => {
  VideoAutoplayType2["ATTENDED"] = "attended";
  VideoAutoplayType2["UNATTENDED"] = "unattended";
  VideoAutoplayType2["NONE"] = "none";
  return VideoAutoplayType2;
})(VideoAutoplayType || {});
const fw_constants = {
  NETWORK_ID: 520311,
  SERVER: "https://7f077.v.fwmrm.net/ad/g/1?",
  PROFILE: "520311:FWCSAI_v01",
  PAL_SDK_URL: "//imasdk.googleapis.com/pal/sdkloader/pal.js",
  FW_SDK_VERSION: "6.55.0"
};
function getNonceMgr(options, consentSettings) {
  return new Promise((resolve) => {
    var _a;
    const w = window;
    const g = typeof w === "object" && w.goog;
    const gp = g == null ? void 0 : g.pal;
    if (!gp || !gp.NonceLoader || !gp.NonceRequest) {
      resolve(null);
    }
    let cs = void 0;
    if (consentSettings && ((_a = Object.keys(consentSettings)) == null ? void 0 : _a.length)) {
      cs = new gp.ConsentSettings();
      cs.allowStorage = consentSettings.allowStorage;
    }
    const nonceLoader = new gp.NonceLoader(cs);
    const req = new gp.NonceRequest();
    Object.keys(options).forEach((k) => {
      const v = options[k];
      if (v !== null) {
        req[k] = v;
      }
    });
    nonceLoader.loadNonceManager(req).then((manager) => {
      resolve(manager);
    }).catch((e) => {
      console.warn(`Avia FW Plugin: NonceManager failed to load: ${e.message}`);
      resolve(null);
    });
  });
}
const FW = "fw";
const AD_END_PROXIMITY = 0.5;
const AD_END_TIMEOUT = 1e3;
class FwAdapter extends AdAdapterBase {
  constructor(options, context) {
    super(options, context);
    this.currentAdIndex = -1;
    this.customIds = {
      PREROLL: "Preroll",
      POSTROLL: "Postroll",
      MIDROLL: "Midroll_"
    };
    this.releasedQuartiles = {
      first: false,
      mid: false,
      third: false
    };
    this.isBuffering = false;
    this.cleaning = false;
    this.adStallTimeout = 5e3;
    this.adPlaying = false;
    this.adPaused = false;
    this.breakInProgress = false;
    this.breakMetadataReleased = false;
    this.isClickToPlay = false;
    this.started = false;
    this.isListeningToAdPlayer = false;
    this.videoSetOnContext = false;
    this.pausedByJsam = false;
    this.hAdPlayerEvent = (event) => {
      var _a, _b, _c;
      const { PlayerEvent } = this.aviaSdk;
      const { detail } = event;
      if (!/progress/.test(event.type)) {
        this.log(`ad PLAYER event: ${event.type}`);
      }
      switch (event.type) {
        case PlayerEvent.CONTENT_START:
          this.started = true;
          if (this.isClickToPlay) {
            this.isClickToPlay = false;
            this.adPlayer.muted = false;
          }
          this.adPlaying = true;
          if (this.delegate) {
            if (!this.breakMetadataReleased) {
              this.breakInProgress = true;
              this.breakMetadataReleased = true;
              this.delegate.adSegmentStarted();
              this.delegate.adBreakStart();
              if (!this.slotHasPlayed(this.currentSlot)) {
                this.markSlotAsPlayed(this.currentSlot);
              }
              this.delegate.adBreakMetadata(this.getBreakData(true));
            }
            this.delegate.adStart(__spreadValues({}, this.adMetadata));
          }
          break;
        case PlayerEvent.CONTENT_PROGRESS:
          clearTimeout(this.adStallHandle);
          if (this.adPaused) {
            return;
          }
          const t = detail.contentTime;
          const d = detail.contentDuration;
          (_a = this.delegate) == null ? void 0 : _a.adProgress(t, d);
          this.checkQuartile(t, d);
          this.armAdEndTimer(t, d);
          break;
        case PlayerEvent.CONTENT_PAUSED:
          clearTimeout(this.adStallHandle);
          clearTimeout(this.adEndHandle);
          break;
        case PlayerEvent.CONTENT_COMPLETE:
          this.completeCurrentAd();
          break;
        case PlayerEvent.VOLUME_CHANGE:
          (_c = (_b = this.adInstance) == null ? void 0 : _b.getRendererController()) == null ? void 0 : _c.processEvent({ name: this.sdk.EVENT_AD_VOLUME_CHANGE });
          break;
        case PlayerEvent.RESOURCE_BUFFERING:
          const { buffering } = detail;
          if (!this.isBuffering && buffering) {
            this.isBuffering = true;
            clearTimeout(this.adEndHandle);
            this.adStallHandle = setTimeout(() => this.handleAdStall(), this.adStallTimeout);
          } else if (this.isBuffering && !buffering) {
            this.isBuffering = false;
            clearTimeout(this.adStallHandle);
          }
          this.delegate.adBuffering(buffering);
          break;
        case PlayerEvent.ERROR:
          clearTimeout(this.adStallHandle);
          clearTimeout(this.adEndHandle);
          this.log(`ad PLAYER ERROR`, detail);
          if (detail.fatal) {
            this.resetAdData();
            this.detachAdPlayer().then(() => {
              var _a2, _b2;
              (_a2 = this.delegate) == null ? void 0 : _a2.adError(detail);
              (_b2 = this.adListener) == null ? void 0 : _b2.onError(detail.message || "Fatal playback error");
            });
          }
          break;
      }
    };
    this.hContextEvent = (event) => {
      const s = this.sdk;
      this.log(`ad CONTEXT event ${event.type}`);
      switch (event.type) {
        case s.EVENT_REQUEST_COMPLETE:
          if (event.success) {
            this.setBreakMetadata();
            this.startAdPlay();
          } else {
            this.cleanUpAndResumeContent();
          }
          break;
        case s.EVENT_AD_IMPRESSION:
          break;
        case s.EVENT_AD_SKIPPABLE_STATE_CHANGED:
          this.delegate.adSkippableStateChanged();
          break;
        case s.EVENT_SLOT_ENDED:
          this.cleanUpAndResumeContent();
          break;
      }
    };
    this.hContentPlayerEvent = (event) => {
      var _a;
      const { PlayerEvent } = this.aviaSdk;
      switch (event.type) {
        case PlayerEvent.CONTENT_PROGRESS:
          if (!this.currentSlot) {
            const t = event.detail.contentTime;
            if (t >= this.player.contentDuration) {
              const s = this.slots.find((s2) => s2.getTimePositionClass() === this.sdk.TIME_POSITION_CLASS_POSTROLL);
              if (s) {
                this.log(`Content end reached;  a POST-roll slot has been found`);
                this.currentSlot = s;
                this.playSlot(s);
              }
            } else {
              const t2 = event.detail.contentTime;
              this.checkExemptSegmentAgainstTime(t2);
              const mid = this.checkForMidroll(t2);
              if (mid) {
                this.log(`PROGRESS indicates time for MID to play; current slot = ${mid.getTimePositionClass()} __ ${mid.getCustomId()}`);
                this.currentSlot = mid;
                this.playSlot(mid);
              }
            }
          }
          break;
        case PlayerEvent.PLAYBACK_STATE_CHANGE:
          if (!this.adPlaying) {
            const state = this.player.playbackState;
            this.setContextPlayState(state);
          }
          break;
        case PlayerEvent.CONTENT_COMPLETE:
          this.setContextPlayState(event.type);
          break;
        case PlayerEvent.FULLSCREEN_CHANGE:
        case PlayerEvent.PRESENTATION_SIZE_CHANGE:
          const dims = this.player.dimensions;
          (_a = this.adContext) == null ? void 0 : _a.resize(dims.width, dims.height);
          break;
      }
    };
    const myOpts = this.options;
    if (!isNaN(myOpts.adStallTimeout)) {
      this.adStallTimeout = myOpts.adStallTimeout;
    }
    this.delegate = context.getDelegate();
    this.slots = [];
    this.slotTimes = [];
    this.slotsPlayed = [];
    this.customPlayer = {
      open: (creativeRendition, adListener) => {
        this.currentAdIndex++;
        this.log(`CPR#open() invoked by SDK, current ad index is ${this.currentAdIndex}`);
        this.isPlayableAd(creativeRendition, adListener).then((ok) => {
          if (ok) {
            this.playCreative(adListener);
          } else {
            this.skipAd();
          }
        });
      },
      getDuration: () => {
        var _a, _b;
        const r = this.adPlaying ? ((_a = this.adPlayer) == null ? void 0 : _a.contentDuration) || null : ((_b = this.player) == null ? void 0 : _b.contentDuration) || null;
        this.log(`CPR#getDuration(): ${r}; obtained from ${this.adPlaying ? "ad" : "content"} player`);
        return r;
      },
      getPlayheadTime: () => {
        var _a, _b;
        this.log(`CPR#getPlayheadTime(): ${!this.adPlaying ? 0 : (((_a = this.adPlayer) == null ? void 0 : _a.contentTime) || 0).toFixed(1)}`);
        if (!this.adPlaying) {
          return 0;
        } else {
          return ((_b = this.adPlayer) == null ? void 0 : _b.contentTime) || 0;
        }
      },
      playPause: (isPause) => {
        var _a, _b;
        this.log(`CPR#playPause(); adPlaying? ${this.adPlaying}; isPause = ${isPause}`);
        if (this.adPlaying) {
          if (isPause && !this.adPaused) {
            this.pausedByJsam = true;
            (_a = this.adPlayer) == null ? void 0 : _a.pause();
          } else if (!isPause && this.pausedByJsam) {
            this.pausedByJsam = false;
            (_b = this.adPlayer) == null ? void 0 : _b.play();
          }
        }
      }
    };
    const sdk = this.sdk;
    sdk.setLogLevel(this.options.debug ? sdk.LOG_LEVEL_DEBUG : sdk.LOG_LEVEL_QUIET);
    this.reportableStates = /* @__PURE__ */ new Map();
    this.reportableStates.set(this.aviaSdk.PlaybackState.PLAYING, sdk.VIDEO_STATE_PLAYING);
    this.reportableStates.set(this.aviaSdk.PlaybackState.PAUSED, sdk.VIDEO_STATE_PAUSED);
    this.reportableStates.set(this.aviaSdk.PlaybackState.STOPPED, sdk.VIDEO_STATE_STOPPED);
    this.reportableStates.set(this.aviaSdk.PlayerEvent.CONTENT_COMPLETE, sdk.VIDEO_STATE_COMPLETED);
    this.listenToContentPlayer(true);
  }
  ////////////
  initializeForClickToPlay() {
    return __async(this, null, function* () {
      yield this.createPlayer();
    });
  }
  /////////////////////////////
  // Ad Adapter Interface
  start() {
    return __async(this, null, function* () {
      this.log(`start()...`);
      return new Promise((resolve) => {
        this.initAdContext().then((ok) => {
          if (ok) {
            this.requestAds();
            resolve();
          } else {
            this.cleanUpAndResumeContent();
            resolve();
          }
        });
      });
    });
  }
  destroy() {
    return __async(this, null, function* () {
      var _a;
      this.log(`destroy()...`);
      this.log("disposing...");
      this.listenToImpressions(false);
      yield this.cleanUp();
      this.listenToContentPlayer(false);
      this.listenToAdContext(false);
      try {
        (_a = this.adContext) == null ? void 0 : _a.dispose();
      } catch (e) {
      }
      this.adContext = null;
      this.adPlayer = null;
      AdAdapterBase.prototype.destroy.call(this);
    });
  }
  // Invoked by delegate on first click-to-play  only
  playClicked() {
    var _a;
    this.isClickToPlay = true;
    (_a = this.adPlayer) == null ? void 0 : _a.primeVideoElement();
  }
  skipAd() {
    var _a, _b, _c, _d, _e, _f;
    if (((_a = this.adMetadata) == null ? void 0 : _a.skippable) || ((_b = this.adMetadata) == null ? void 0 : _b.skip)) {
      clearTimeout(this.adEndHandle);
      (_c = this.delegate) == null ? void 0 : _c.adSkipped();
      ((_d = this.adMetadata) == null ? void 0 : _d.skippable) && ((_e = this.delegate) == null ? void 0 : _e.adComplete());
      (_f = this.currentSlot) == null ? void 0 : _f.skipCurrentAd();
    }
  }
  resume() {
    return __async(this, null, function* () {
      var _a;
      this.log(`resume()...`);
      this.adPaused = false;
      if (!this.adPlayer || !this.started) {
        return;
      }
      (_a = this.adPlayer) == null ? void 0 : _a.play().then(() => {
        var _a2;
        (_a2 = this.currentSlot) == null ? void 0 : _a2.resume();
        this.delegate.adResumed();
      });
    });
  }
  pause() {
    return __async(this, null, function* () {
      var _a;
      this.log(`pause()...`);
      if (this.adPaused || !this.adPlayer || !this.started) {
        return;
      }
      (_a = this.adPlayer) == null ? void 0 : _a.pause().then(() => {
        var _a2;
        (_a2 = this.currentSlot) == null ? void 0 : _a2.pause();
        this.delegate.adPaused();
      });
    });
  }
  getPermittedSeekTime(requestedContentSeekTime) {
    return __async(this, null, function* () {
      this.log(`getPermittedSeekTime( requestedContentSeekTime = ${requestedContentSeekTime} )`);
      if (this.timeLiesWithinExemptSegment(requestedContentSeekTime)) {
        return requestedContentSeekTime;
      }
      const midroll = this.checkForMidroll(requestedContentSeekTime);
      if (midroll) {
        this.log(`potential midroll break identified...`);
        this.currentSlot = midroll;
        this.playSlot(midroll);
        return requestedContentSeekTime - 0.1;
      }
      return requestedContentSeekTime;
    });
  }
  setVolume(volume) {
    if (!this.adPlayer || !this.started) {
      return;
    }
    this.adPlayer.muted = this.player.muted;
    this.adPlayer.volume = volume;
  }
  setMuteState(muted) {
    if (!this.adPlayer || !this.started) {
      return;
    }
    this.adPlayer.muted = muted;
    this.adPlayer.volume = muted ? 0 : this.player.volume;
  }
  updateSize(dimensions) {
    var _a;
    const { width, height } = dimensions;
    this.log(`updateSize() w, h = ; ${width}, ${height}`);
    (_a = this.adContext) == null ? void 0 : _a.resize(width, height);
  }
  // no-op
  handleTimedMetadata() {
  }
  setStreamTime() {
  }
  setStreamDuration() {
  }
  contentComplete() {
  }
  setContentBitrate(value) {
  }
  setFullscreenState(value) {
  }
  getId() {
    return FW;
  }
  get info() {
    return {
      id: this.getId(),
      version: "",
      adTechnology: this.aviaSdk.AdTechnology.CSAI
    };
  }
  // END AD ADAPTER IFACE
  ///////////////////////
  get adManager() {
    return this.opts.adManager || null;
  }
  get sdk() {
    return this.opts.sdk;
  }
  get adContainer() {
    return this.options.adContainer;
  }
  get adClickElement() {
    var _a, _b, _c;
    const isDesktop = (_b = (_a = this.context) == null ? void 0 : _a.system) == null ? void 0 : _b.isDesktop;
    return isDesktop ? this.adContainer : (_c = this.context) == null ? void 0 : _c.dom.adClickEl;
  }
  get opts() {
    return this.options;
  }
  //////////////////////////
  // Ad play mgt
  isPlayableAd(creativeRendition, adListener) {
    return __async(this, null, function* () {
      this.setAdMetadata(creativeRendition, adListener);
      if (!this.adMetadata) {
        this.log(`isPlayableAd(); ad metadata is undefined; returning FALSE`);
        return false;
      }
      this.adMetadata = yield this.delegate.applyHook(this.aviaSdk.PlayerHookType.AD, this.adMetadata);
      this.log(`isPlayableAd(); should play? ${!this.adMetadata.skip}`);
      return !this.adMetadata.skip;
    });
  }
  startAdPlay() {
    return __async(this, null, function* () {
      const slot = this.getSlot(0);
      this.log(`startAdPlay(); using slot[0]`);
      if (!slot || this.slotHasPlayed(slot)) {
        this.log(`startAdPlay(); slot[0] ${slot ? "has played already" : "is undefined"}; will NOT play`);
        this.cleanUpAndResumeContent();
        return;
      }
      this.showAdContainer(true);
      this.breakMetadataReleased = false;
      this.currentSlot = slot;
      this.log(`startAdPlay(); invoking slot.play()`);
      this.currentSlot.play();
    });
  }
  /**
   * Completes the creative in progress and moves the pod on. Reached from the ad player's
   * completion event, or from the end-of-creative timer when that event never arrives.
   */
  completeCurrentAd() {
    var _a, _b, _c;
    clearTimeout(this.adStallHandle);
    this.adPlaying = false;
    this.adPaused = false;
    if (this.adMetadata) {
      (_a = this.adListener) == null ? void 0 : _a.onEnded();
      (_b = this.delegate) == null ? void 0 : _b.adComplete();
    }
    this.resetAdData();
    const ct = ((_c = this.currentSlot) == null ? void 0 : _c.getAdCount()) || 1;
    if (ct === 1 || this.currentAdIndex === ct) {
      this.cleanUpAndResumeContent();
    }
  }
  /**
   * Restarts the end-of-creative wait on every progress sample taken within
   * `AD_END_PROXIMITY` of the duration, so it expires only once samples stop arriving.
   */
  armAdEndTimer(t, d) {
    clearTimeout(this.adEndHandle);
    if (isNaN(d) || isNaN(t) || d - t > AD_END_PROXIMITY) {
      return;
    }
    this.adEndHandle = setTimeout(() => this.handleAdEnd(), AD_END_TIMEOUT);
  }
  handleAdEnd() {
    this.log(`handleAdEnd(): creative stopped at its end without reporting completion`);
    this.listenToAdPlayer(false);
    this.completeCurrentAd();
  }
  handleAdStall() {
    this.log(`handleAdStall()...`);
    this.delegate.adStalled(this.adMetadata);
    this.delegate.adBreakDiscarded();
    this.cleanUpAndResumeContent();
  }
  setBreakMetadata() {
    this.log("setBreakMetadata()...");
    const slots = this.adContext.getTemporalSlots().slice();
    const { AdBreakType } = this.aviaSdk;
    if (!slots || !slots.length) {
      this.log("No slots found.");
      return;
    }
    slots.sort((s1, s2) => {
      return s1.getTimePosition() > s2.getTimePosition() ? 1 : -1;
    });
    this.slots = slots;
    const breakMetadata = [];
    const { resource } = this.context;
    const startTime = resource.playback.startTime;
    const isNonZeroStart = !isNaN(startTime) && startTime > 0;
    const markPrerollPlayed = isNonZeroStart && !resource.ad.showPrerollOnNonZeroStart;
    this.slots.forEach((slot, i) => {
      const id = slot.getCustomId();
      const type = this.getBreakType(slot);
      this.log(`Received SLOT: ${i}; ${slot.getCustomId()}; ${slot.getTimePositionClass()} @ ${Math.round(slot.getTimePosition())}; dur = ${Math.round(slot.getTotalDuration())}`);
      if (type === AdBreakType.PRE && markPrerollPlayed) {
        this.markSlotAsPlayed(slot);
      }
      const d = {
        type,
        adBreakType: type,
        startTime: slot.getTimePosition(),
        hasPlayed: type === AdBreakType.PRE ? markPrerollPlayed : false,
        breakId: id,
        duration: slot.getTotalDuration(),
        adBreakPosition: i,
        adTotal: slot.getAdCount(),
        adServerName: "freewheel",
        adTechnology: this.aviaSdk.AdTechnology.CSAI
      };
      this.slotTimes.push(slot.getTimePosition());
      breakMetadata.push(d);
    });
    if (isNonZeroStart) {
      let i = this.slotTimes.length;
      while (i--) {
        const t = this.slotTimes[i];
        const slot = this.slots[i];
        if (t > 0 && t <= startTime) {
          const { discardPrecedingBreakOnContentResume } = this.getOptions();
          if (discardPrecedingBreakOnContentResume === false) {
            const startTime2 = slot.getTimePosition();
            const upperLimit = this.slotTimes[i + 1] || this.player.contentDuration;
            this.exemptSegment = [startTime2, upperLimit];
          } else {
            this.markSlotAsPlayed(slot);
            breakMetadata[i].hasPlayed = true;
          }
          break;
        }
      }
    }
    this.allBreaksMetadata = breakMetadata;
    this.delegate.adBreaksAvailable(breakMetadata);
  }
  getBreakData(hasPlayed) {
    if (!this.currentSlot) {
      return null;
    }
    const slot = this.currentSlot;
    const type = this.getBreakType(slot);
    return {
      type,
      adBreakType: type,
      startTime: slot.getTimePosition(),
      hasPlayed,
      breakId: slot.getCustomId(),
      duration: slot.getTotalDuration(),
      adBreakPosition: this.getBreakPosition(slot),
      adTotal: slot.getAdCount(),
      adServerName: "freewheel",
      adTechnology: this.aviaSdk.AdTechnology.CSAI,
      skip: false
    };
  }
  setAdMetadata(rendition, adListener) {
    var _a, _b;
    const ads = (_a = this.currentSlot) == null ? void 0 : _a.getAdInstances();
    const ad = ads == null ? void 0 : ads[this.currentAdIndex];
    const adId = ad == null ? void 0 : ad.getAdId();
    if (!ad) {
      this.adMetadata = null;
      return;
    }
    const skipOffset = ad.getSkipOffset();
    const all = ad.getRenderableCreativeRenditions();
    const selected = this.selectCreativeVariant(all) || ad.getActiveCreativeRendition();
    const asset = selected.getPrimaryCreativeRenditionAsset();
    this.log(`Current ad ID: ${adId}`);
    this.adMetadata = {
      adId,
      adPosition: this.currentAdIndex + 1,
      adTitle: asset.getName() || "",
      adDuration: selected.getDuration(),
      adObject: ad,
      skippable: skipOffset >= 0,
      skip: false,
      skipOffset,
      adAssetUrl: asset.getProxiedUrl(),
      isVpaid: false,
      clickThroughUrl: ((_b = adListener.getClickThroughUrls()) == null ? void 0 : _b.join(",")) || "",
      // @ts-ignore
      creativeId: ad._creativeId || ""
    };
  }
  selectCreativeVariant(creatives) {
    const contentBr = Math.round(this.player.bitrate * 1e-3);
    if (!isNaN(contentBr) && contentBr > 0) {
      const chosenCreative = creatives.reduce((chosen, creative) => {
        const r = creative._bitrate;
        const chosenBitrate = (chosen == null ? void 0 : chosen._bitrate) || 0;
        if (r && !isNaN(r) && r - contentBr <= 0 && r > chosenBitrate) {
          return creative;
        }
        return chosen;
      });
      if (chosenCreative) {
        this.log(`selectCreativeVariant(); chose bitrate = ${chosenCreative._bitrate}`);
        return chosenCreative;
      }
    }
    const { width } = this.player.dimensions;
    this.log(`selectCreativeVariant(); will use player width = ${width}`);
    creatives.sort((c1, c2) => {
      const w1 = c1.getWidth();
      const w2 = c2.getWidth();
      let r = w1 > w2 ? 1 : w1 < w2 ? -1 : 0;
      if (c1._bitrate) {
        if (r === 0) {
          r = c1._bitrate < c2._bitrate ? 1 : -1;
        }
      }
      return r;
    });
    let i = creatives.length;
    while (i--) {
      const cw = creatives[i].getWidth();
      if (cw <= width) {
        this.log(`selectCreativeVariant(); returning creative width = ${cw}`);
        return creatives[i];
      }
    }
    this.log(`selectCreativeVariant(); returning NULL!`);
    return null;
  }
  setContextPlayState(state) {
    var _a;
    const mappedState = this.reportableStates.get(state);
    if (mappedState) {
      (_a = this.adContext) == null ? void 0 : _a.setVideoState(mappedState);
    }
  }
  slotHasPlayed(slot) {
    return !slot || slot && this.slotsPlayed.includes(slot.getCustomId());
  }
  markSlotAsPlayed(slot) {
    if (slot) {
      this.slotsPlayed.push(slot.getCustomId());
      if (this.allBreaksMetadata) {
        const b = this.allBreaksMetadata.find((b2) => b2.breakId === slot.getCustomId());
        if (b) {
          b.hasPlayed = true;
        }
      }
    }
  }
  timeLiesWithinExemptSegment(t) {
    return this.exemptSegment && (t >= this.exemptSegment[0] && t <= this.exemptSegment[1]);
  }
  checkExemptSegmentAgainstTime(t) {
    if (this.exemptSegment) {
      if (t < this.exemptSegment[0] || t > this.exemptSegment[1]) {
        this.exemptSegment = null;
      }
    }
  }
  getBreakType(slot) {
    const tc = slot == null ? void 0 : slot.getTimePositionClass();
    switch (tc) {
      case this.sdk.TIME_POSITION_CLASS_PREROLL:
        return this.aviaSdk.AdBreakType.PRE;
      case this.sdk.TIME_POSITION_CLASS_POSTROLL:
        return this.aviaSdk.AdBreakType.POST;
      case this.sdk.TIME_POSITION_CLASS_MIDROLL:
        return this.aviaSdk.AdBreakType.MID;
      default:
        return this.aviaSdk.AdBreakType.MID;
    }
  }
  getBreakPosition(slot) {
    return this.slotTimes.indexOf(slot.getTimePosition());
  }
  checkQuartile(t, d) {
    const f = t / d;
    if (f >= 0.75 && !this.releasedQuartiles.third) {
      this.releasedQuartiles.third = true;
      this.delegate.adThirdQuartile();
    } else if (f >= 0.5 && !this.releasedQuartiles.mid) {
      this.releasedQuartiles.mid = true;
      this.delegate.adMidpoint();
    } else if (f >= 0.25 && !this.releasedQuartiles.first) {
      this.releasedQuartiles.first = true;
      this.delegate.adFirstQuartile();
    }
  }
  cleanUpAndResumeContent() {
    this.log(`cleanUpAndResumeContent()`);
    if (this.cleaning) {
      return;
    }
    this.cleaning = true;
    this.adInstance = null;
    this.cleanUp().then(() => {
      var _a, _b;
      if (this.breakInProgress) {
        (_a = this.delegate) == null ? void 0 : _a.adBreakComplete();
        (_b = this.delegate) == null ? void 0 : _b.adSegmentEnded();
      }
      this.log(`cleanUpAndResumeContent(); will instruct delegate to resume...`);
      this.breakInProgress = false;
      this.cleaning = false;
      this.delegate.resumeContent();
      this.checkAllAdsComplete();
    });
  }
  getSlot(time) {
    const slots = this.adContext.getTemporalSlots();
    const slot = slots.find((slot2) => Math.floor(slot2.getTimePosition()) === time);
    this.log(`getSlot(time=${time}); will return slot with custom ID ${slot == null ? void 0 : slot.getCustomId()}`);
    return slot;
  }
  checkForMidroll(t) {
    const mids = this.slots.filter((s) => s.getTimePositionClass() === this.sdk.TIME_POSITION_CLASS_MIDROLL);
    let i = this.slotTimes.length;
    while (i--) {
      const sTime = this.slotTimes[i];
      if (t >= sTime) {
        const mid = mids.find((s) => Math.floor(s.getTimePosition()) === Math.floor(sTime));
        const exempt = this.timeLiesWithinExemptSegment(t);
        if (!exempt && mid && !this.slotHasPlayed(mid)) {
          this.log(`checkForMidroll(time=${t}) found ${mid.getTimePositionClass()}  ${mid.getCustomId()} @ ${mid.getTimePosition()}`);
          return mid;
        }
        return null;
      }
    }
    return null;
  }
  playSlot(slot) {
    const breakData = this.getBreakData(false);
    this.log(`playSlot(): ${slot.getTimePositionClass()} | ${slot.getCustomId()};`);
    this.delegate.applyHook(this.aviaSdk.PlayerHookType.AD_BREAK, breakData).then((data) => {
      if (data.skip !== true) {
        this.markSlotAsPlayed(slot);
        this.breakMetadataReleased = false;
        this.showAdContainer(true);
        this.log(`invoking slot.play() for slot ${slot.getTimePositionClass()} | ${slot.getCustomId()}`);
        slot.play();
      } else {
        this.currentSlot = null;
        const isPost = slot.getTimePositionClass() === this.sdk.TIME_POSITION_CLASS_POSTROLL;
        if (data.hasPlayed === true || isPost) {
          this.markSlotAsPlayed(slot);
          if (isPost) {
            this.log(`post-roll is skipped`);
            setTimeout(() => this.delegate.resumeContent(), 20);
          }
        } else {
          const startTime = slot.getTimePosition();
          const idx = this.slotTimes.findIndex((v) => v === startTime);
          this.exemptSegment = [startTime, this.slotTimes[idx + 1] || this.player.contentDuration];
        }
      }
    });
  }
  playCreative(adListener) {
    const url = this.adMetadata.adAssetUrl;
    this.log(`playCreative()...`);
    if (!url) {
      this.log(`Asset URL is null`);
      this.cleanUpAndResumeContent();
      return;
    }
    this.delegate.pauseContent();
    this.adListener = adListener;
    this.createPlayer().then(() => {
      this.playAd(url);
    }).catch((e) => {
      this.log(e.message);
      this.cleanUpAndResumeContent();
    });
  }
  playAd(url) {
    var _a;
    this.listenToAdPlayer(true);
    (_a = this.adPlayer) == null ? void 0 : _a.attachResource({ location: { mediaUrl: url } }).then(() => {
      this.setVideoOnContext();
      const { muted, volume } = this.player;
      if (!this.currentSlotIsPreroll()) {
        try {
          this.adPlayer.muted = muted;
          this.adPlayer.volume = muted ? 0 : volume;
        } catch (e) {
          this.log(e.message);
        }
      }
    }).catch((e) => {
      this.log(e.message);
      this.cleanUpAndResumeContent();
    });
  }
  createPlayer() {
    return __async(this, null, function* () {
      if (this.adPlayer) {
        return Promise.resolve();
      }
      this.log(`createPlayer() (for ads)...`);
      const autoplayState = this.getInitialAutoplayStateForAdPlayer();
      const options = this.getAdPlayerOptions(autoplayState);
      return this.aviaSdk.createVideoPlayer(options).then((p) => {
        this.adPlayer = p;
        this.listenToAdPlayer(true);
      }).catch((e) => {
        throw new Error(`Ad Player Creation Error:${e.message}`);
      });
    });
  }
  getAdPlayerOptions(autoplay) {
    const a = this.aviaSdk;
    const hostOptions = this.context.playerOptions;
    const plugins = (hostOptions.plugins || []).filter((cfg) => /hlsjs|hls|dashjs|dash|shaka/.test(cfg.id));
    const adPlayerOptions = {
      container: this.adContainer,
      id: "avia_ap_" + Date.now(),
      logLevel: this.options.debug ? a.LogLevel.DEBUG : a.LogLevel.ERROR,
      playsInline: true,
      reuseVideoElement: true,
      renderTextTrackNatively: true,
      overrides: {
        closeOnEnded: true,
        endFreezeThreshold: 0
      },
      performanceMode: hostOptions.performanceMode || void 0,
      plugins,
      autoplay
    };
    return adPlayerOptions;
  }
  setVideoOnContext() {
    var _a;
    if (this.videoSetOnContext || !this.adPlayer || !this.adContext) {
      return;
    }
    const video = this.adPlayer.video;
    if (!video) {
      this.log("no video: unable to set video on context; returning");
      return;
    }
    const f = video.play;
    video.play = () => __async(this, null, function* () {
      f.call(video).catch((e) => {
        if (this.options.debug) {
          console.warn(`Ad Player: caught in play() Promise: ${e.message}`);
        }
      });
    });
    if (this.player.muted) {
      this.adPlayer.volume = 0;
      this.adPlayer.muted = true;
    }
    this.videoSetOnContext = true;
    (_a = this.adContext) == null ? void 0 : _a.setContentVideoElement(video);
  }
  currentSlotIsPreroll() {
    var _a;
    return ((_a = this.currentSlot) == null ? void 0 : _a.getTimePositionClass()) === this.sdk.TIME_POSITION_CLASS_PREROLL;
  }
  checkAllAdsComplete() {
    var _a;
    let complete = true;
    this.slots.forEach((s) => {
      if (!this.slotHasPlayed(s)) {
        complete = false;
      }
    });
    if (complete) {
      (_a = this.adContext) == null ? void 0 : _a.setVideoState(this.sdk.VIDEO_STATE_COMPLETED);
      this.delegate.allAdsComplete();
    }
  }
  cleanUp() {
    return __async(this, null, function* () {
      this.log("internal clean up starting...");
      this.currentSlot = null;
      this.currentAdIndex = -1;
      this.resetAdData();
      this.showAdContainer(false);
      this.showAdClickElement(false);
      yield this.detachAdPlayer();
      this.log("internal clean up complete");
    });
  }
  detachAdPlayer() {
    return __async(this, null, function* () {
      if (!this.adPlayer) {
        return Promise.resolve();
      }
      this.listenToAdPlayer(false);
      yield this.adPlayer.stop();
    });
  }
  resetAdData() {
    clearTimeout(this.adEndHandle);
    this.releasedQuartiles = {
      first: false,
      mid: false,
      third: false
    };
    this.adMetadata = null;
    this.adPlaying = false;
    this.adPaused = false;
  }
  getInitialAutoplayStateForAdPlayer() {
    const a = this.aviaSdk;
    const aps = this.options.autoplayState;
    if (aps.autoplay) {
      return aps.muted ? a.Autoplay.ATTEMPT_MUTED : a.Autoplay.ATTEMPT_UNMUTED_THEN_MUTED;
    } else {
      return a.Autoplay.ATTEMPT_UNMUTED_THEN_MUTED;
    }
  }
  showAdContainer(flag) {
    const ac = this.adContainer;
    if (ac) {
      ac.style.display = flag ? "block" : "none";
    }
  }
  showAdClickElement(flag) {
    const sys = this.context.system;
    const useClickEl = sys.isIos || sys.isMobile || sys.isAndroid;
    if (useClickEl) {
      this.delegate.displayAdClickElement(flag);
    }
  }
  //////////////////////////////
  // Add/remove Event Listeners
  listenToAdContext(flag) {
    if (!this.adContext) {
      return;
    }
    const verb = `${flag !== false ? "add" : "remove"}EventListener`;
    this.getContextEvents().forEach((e) => {
      this.adContext[verb](e, this.hContextEvent);
    });
  }
  listenToAdPlayer(flag) {
    if (!this.adPlayer) {
      return;
    }
    if (flag && this.isListeningToAdPlayer) {
      return;
    }
    this.isListeningToAdPlayer = flag;
    const verb = flag ? "on" : "off";
    this.getAviaAdPlayerEvents().forEach((event) => {
      this.adPlayer[verb](event, this.hAdPlayerEvent);
    });
  }
  listenToContentPlayer(flag) {
    const contentPlayer = this.player;
    if (!contentPlayer) {
      return;
    }
    const arr = this.getAviaContentPlayerEvents();
    const verb = flag ? "on" : "off";
    arr.forEach((event) => {
      contentPlayer[verb](event, this.hContentPlayerEvent);
    });
  }
  // Click-through handling done here
  listenToImpressions(flag = true) {
    var _a, _b, _c, _d;
    const adClickEl = this.adClickElement;
    if (!adClickEl) {
      return;
    }
    const containerClickHandler = () => {
      var _a2, _b2, _c2, _d2, _e, _f;
      this.adPaused = true;
      this.adPlayer.pause();
      (_a2 = this.currentSlot) == null ? void 0 : _a2.pause();
      const u = ((_b2 = this.adListener.getClickThroughUrls()) == null ? void 0 : _b2.join(",")) || "";
      (_c2 = this.delegate) == null ? void 0 : _c2.adClicked(u);
      (_d2 = this.delegate) == null ? void 0 : _d2.adPaused();
      (_f = (_e = this.adInstance) == null ? void 0 : _e.getRendererController()) == null ? void 0 : _f.processEvent({ name: this.sdk.EVENT_AD_CLICK });
    };
    const adImpressionEventHandler = (event) => {
      var _a2;
      if (event.type === this.sdk.EVENT_AD_IMPRESSION) {
        this.adInstance = event.adInstance;
        if (((_a2 = this.adListener) == null ? void 0 : _a2.getClickThroughUrls().length) > 0) {
          this.showAdClickElement(true);
          adClickEl == null ? void 0 : adClickEl.addEventListener("click", containerClickHandler);
          return;
        }
      } else {
        this.showAdClickElement(false);
        this.adInstance = null;
        adClickEl == null ? void 0 : adClickEl.removeEventListener("click", containerClickHandler);
      }
    };
    if (!flag) {
      this.adInstance = null;
      adClickEl.removeEventListener("click", containerClickHandler);
      this.showAdClickElement(false);
      (_a = this.adContext) == null ? void 0 : _a.removeEventListener(this.sdk.EVENT_AD_IMPRESSION, adImpressionEventHandler);
      (_b = this.adContext) == null ? void 0 : _b.removeEventListener(this.sdk.EVENT_AD_IMPRESSION_END, adImpressionEventHandler);
    } else {
      (_c = this.adContext) == null ? void 0 : _c.addEventListener(this.sdk.EVENT_AD_IMPRESSION_END, adImpressionEventHandler);
      (_d = this.adContext) == null ? void 0 : _d.addEventListener(this.sdk.EVENT_AD_IMPRESSION, adImpressionEventHandler);
    }
  }
  ////////////////////////////
  // Init Ad Context
  initAdContext() {
    return __async(this, null, function* () {
      const cfg = this.csaiCfg;
      let nonce = "";
      if (this.options.skipPalNonce !== true) {
        try {
          const { options, consentSettings } = this.getNonceOptions();
          const nonceMgr = yield getNonceMgr(options, consentSettings);
          nonce = (nonceMgr == null ? void 0 : nonceMgr.getNonce()) || "";
        } catch (e) {
          this.log(`Failed to retrieve nonce; ${(e == null ? void 0 : e.message) || ""}`);
        }
      }
      const sdk = this.sdk;
      this.adContext = this.adManager.newContext();
      const ac = this.adContext;
      ac.setParameter(sdk.PARAMETER_ENABLE_JS_TRANSPORT, true, sdk.PARAMETER_LEVEL_GLOBAL);
      if (this.context.playerOptions.enableOm) {
        ac.setParameter(sdk.PARAMETER_EXTENSION_OMSDK_ENABLED, true, sdk.PARAMETER_LEVEL_GLOBAL);
      }
      ac.setParameter("renderer.video.clickDetection", false, sdk.PARAMETER_LEVEL_GLOBAL);
      ac.setParameter(sdk.PARAMETER_EXTENSION_CONTENT_VIDEO_ENABLED, false, sdk.PARAMETER_LEVEL_GLOBAL);
      this.listenToImpressions(true);
      const vprn = this.rand16();
      const pvrn = this.rand16();
      const prof = cfg.profile || fw_constants.PROFILE;
      const nw = cfg.networkId || fw_constants.NETWORK_ID;
      ac.setProfile(prof);
      const caps = cfg.capabilities;
      const callbackCap = "CAPABILITY_REQUIRE_ADVANCED_CALLBACK";
      ac.setCapability(
        sdk[callbackCap],
        (caps == null ? void 0 : caps[callbackCap]) === false ? sdk.CAPABILITY_STATUS_OFF : sdk.CAPABILITY_STATUS_ON
      );
      ac.setVideoAsset(
        cfg.videoAsset.id,
        cfg.videoAsset.duration,
        nw,
        null,
        this.getAutoplayType(),
        vprn
      );
      for (const q in caps) {
        if (q !== callbackCap) {
          ac.setCapability(
            sdk[q],
            caps[q] ? sdk.CAPABILITY_STATUS_ON : sdk.CAPABILITY_STATUS_OFF
          );
        }
      }
      ac.setSiteSection(cfg.siteSection.id, nw, pvrn);
      ac.addKeyValue("paln", nonce);
      if (cfg.customParameters) {
        for (const p in cfg.customParameters) {
          ac.addKeyValue(p, String(cfg.customParameters[p]));
        }
      }
      const breakTimes = cfg.adBreakTimes && cfg.adBreakTimes.length ? cfg.adBreakTimes : [];
      breakTimes.sort((a, b) => a > b ? 1 : -1);
      const rnd = () => Math.round(Math.random() * 1e6);
      breakTimes.forEach((t) => {
        if (t === 0) {
          ac.addTemporalSlot(this.customIds.PREROLL, sdk.ADUNIT_PREROLL, 0);
        } else if (t === -1) {
          ac.addTemporalSlot(this.customIds.POSTROLL, sdk.ADUNIT_POSTROLL, -1);
        } else {
          const mid = `${this.customIds.MIDROLL}${t}_${rnd()}`;
          ac.addTemporalSlot(`${mid}`, sdk.ADUNIT_MIDROLL, t);
        }
      });
      ac.registerCustomPlayer(this.customPlayer);
      const d = this.player.dimensions;
      ac.setVideoDisplaySize(0, 0, d.width, d.height);
      yield this.createPlayer();
      const adc = this.adContainer;
      const adcId = `ac_${Math.round(Math.random() * 1e8)}`;
      adc.setAttribute("id", adcId);
      ac.registerVideoDisplayBase(adcId);
      this.listenToAdContext(true);
      return true;
    });
  }
  getAutoplayType() {
    const cfg = this.csaiCfg;
    const caps = cfg.capabilities;
    let apValue = this.sdk.VIDEO_ASSET_AUTO_PLAY_TYPE_UNATTENDED;
    const apType = caps == null ? void 0 : caps.VIDEO_ASSET_AUTO_PLAY_TYPE;
    if (apType !== void 0) {
      apValue = apType === VideoAutoplayType.ATTENDED ? this.sdk.VIDEO_ASSET_AUTO_PLAY_TYPE_ATTENDED : apType === VideoAutoplayType.NONE ? null : apValue;
    }
    return apValue;
  }
  getNonceOptions() {
    const dims = this.player.dimensions;
    return {
      options: {
        adWillAutoPlay: this.options.autoplayState.autoplay,
        adWillPlayMuted: this.options.autoplayState.muted,
        continuousPlayback: this.csaiCfg.continuousPlayback === true,
        descriptionUrl: this.csaiCfg.descriptionUrl || "",
        iconsSupported: this.csaiCfg.iconsSupported === true,
        nonceLengthLimit: this.csaiCfg.nonceLengthLimit || null,
        omidPartnerName: this.csaiCfg.omidPartnerName || null,
        omidPartnerVersion: this.csaiCfg.omidPartnerVersion || null,
        omidVersion: this.csaiCfg.omidVersion || null,
        playerVersion: this.context.buildInfo.playerVersion,
        playerType: this.context.buildInfo.playerName,
        ppid: this.csaiCfg.ppid || null,
        sessionId: this.csaiCfg.sessionId || null,
        supportedApiFrameworks: this.csaiCfg.supportedApiFrameworks || null,
        videoWidth: dims.width,
        videoHeight: dims.height
      },
      consentSettings: this.csaiCfg.consentSettings || null
    };
  }
  getOptions() {
    return this.options;
  }
  getContextEvents() {
    const { sdk } = this;
    if (!sdk) {
      return [];
    }
    return [
      sdk.EVENT_REQUEST_COMPLETE,
      sdk.EVENT_AD_SKIPPABLE_STATE_CHANGED,
      sdk.EVENT_SLOT_STARTED,
      sdk.EVENT_SLOT_ENDED,
      sdk.EVENT_AD_AUTO_PLAY_BLOCKED,
      sdk.EVENT_EXTENSION_LOADED,
      sdk.EVENT_CONTENT_VIDEO_PAUSE_REQUEST,
      sdk.EVENT_CONTENT_VIDEO_RESUME_REQUEST,
      sdk.EVENT_AD_IMPRESSION,
      sdk.EVENT_AD_IMPRESSION_END,
      sdk.EVENT_AD_CLICK,
      sdk.ERROR_TIMEOUT,
      sdk.ERROR_PARSE
    ];
  }
  getAviaAdPlayerEvents() {
    const { PlayerEvent } = this.aviaSdk;
    return [
      PlayerEvent.CONTENT_START,
      PlayerEvent.CONTENT_PLAYING,
      PlayerEvent.CONTENT_PROGRESS,
      PlayerEvent.CONTENT_PAUSED,
      PlayerEvent.CONTENT_COMPLETE,
      PlayerEvent.VOLUME_CHANGE,
      PlayerEvent.ERROR,
      PlayerEvent.RESOURCE_BUFFERING
    ];
  }
  getAviaContentPlayerEvents() {
    const { PlayerEvent } = this.aviaSdk;
    return [
      PlayerEvent.PLAYBACK_STATE_CHANGE,
      PlayerEvent.CONTENT_PROGRESS,
      PlayerEvent.CONTENT_COMPLETE
    ];
  }
  rand16() {
    let n = String(Math.round(1e15 + Math.random() * 9e15));
    if (n.length < 16) {
      while (n.length < 16) {
        n += "0";
      }
    }
    if (n.length > 16) {
      n = n.substring(0, 17);
    }
    return parseInt(n);
  }
  requestAds() {
    this.adContext.submitRequest();
  }
}
function fw(options = {}) {
  return {
    id: FW,
    factory: createFwPlugin,
    options
  };
}
function createFwPlugin(services, options) {
  var _a;
  const { player, avia } = services;
  let adManager;
  let adapter;
  const palSdkLoaded = function() {
    const w = window;
    return !!((w == null ? void 0 : w.goog) && w.goog.pal);
  };
  const sdkUrl = ((_a = options == null ? void 0 : options.dependencies) == null ? void 0 : _a.fw) || null;
  player.registerAdapter({
    id: FW,
    role: [avia.AdapterRole.AD],
    options,
    factory: function createFwAdapter(context, options2) {
      return __async(this, null, function* () {
        var _a2;
        const { resource } = context;
        const fwCfg = (_a2 = resource.ad) == null ? void 0 : _a2.csai;
        const { ErrorCode, PlayerError, Util } = avia;
        const create = () => __async(null, null, function* () {
          var _a3, _b, _c, _d, _e, _f;
          const { system, dom } = context;
          if (!((_c = (_b = (_a3 = system.global) == null ? void 0 : _a3.tv) == null ? void 0 : _b.freewheel) == null ? void 0 : _c.SDK)) {
            try {
              yield Util.loadScript(
                { url: sdkUrl || `https://mssl.fwmrm.net/libs/adm/${fw_constants.FW_SDK_VERSION}/AdManager.js` },
                context.playerOptions,
                () => {
                  var _a4, _b2;
                  return (_b2 = (_a4 = system.global.tv) == null ? void 0 : _a4.freewheel) == null ? void 0 : _b2.SDK;
                }
              );
            } catch (error) {
              throw new PlayerError(ErrorCode.FW_SDK_MISSING, "Could not load hls.js SDK", error);
            }
          }
          const sdk = (_f = (_e = (_d = system.global) == null ? void 0 : _d.tv) == null ? void 0 : _e.freewheel) == null ? void 0 : _f.SDK;
          if (!sdk) {
            const message = "FW SDK not found";
            throw new PlayerError(ErrorCode.FW_SDK_MISSING, message, { message, name: "" });
          }
          if (!adManager) {
            adManager = new sdk.AdManager();
            adManager.setNetwork(fwCfg.networkId || fw_constants.NETWORK_ID);
            adManager.setServer(fwCfg.server || fw_constants.SERVER);
          }
          return new FwAdapter({
            adContainer: options2.adContainer || dom.adContainer,
            playheadInterface: options2.playheadInterface || dom.video,
            presentationContainer: options2.presentationContainer || dom.main,
            autoplayState: {
              muted: context.muted,
              autoplay: context.autoplay
            },
            debug: !!options2.debug,
            adManager,
            skipPalNonce: options2.skipPalNonce,
            adStallTimeout: options2.adStallTimeout,
            discardPrecedingBreakOnContentResume: options2.discardPrecedingBreakOnContentResume,
            sdk
          }, context);
        });
        if (fwCfg) {
          if (!palSdkLoaded()) {
            yield avia.Util.loadScript({ url: fw_constants.PAL_SDK_URL });
          }
          adapter = yield create();
          if (!context.autoplay) {
            yield adapter.initializeForClickToPlay();
          }
          return adapter;
        }
        return null;
      });
    },
    isSupported: (context) => {
      var _a2, _b, _c;
      return (_c = (_b = (_a2 = context.resource) == null ? void 0 : _a2.ad) == null ? void 0 : _b.csai) == null ? void 0 : _c.networkId;
    }
  });
  return {
    getId() {
      return FW;
    },
    destroy() {
      adapter = null;
      adManager = null;
    },
    skipAd() {
      adapter.skipAd();
    }
  };
}
const ID = FW;
const createPlugin = createFwPlugin;
const plugin = fw;
exports.ID = ID;
exports.VideoAutoplayType = VideoAutoplayType;
exports.createFwPlugin = createFwPlugin;
exports.createPlugin = createPlugin;
exports.fw = fw;
exports.plugin = plugin;
//# sourceMappingURL=avia.fw.cjs.map
